import Instruction from "./Instruction";

/**
 * Show a message in the chat, by defaut as the bot but can be as the user.
 *
 * If a message is from the user it can allow to come back to change it's answer (by default), or not.
 *
 * text can be resolve at runtime.
 */
class Message extends Instruction
{
	constructor(text, isWarning = false)
	{
		super();
		this.text = text;
		this.fromUser = false;
		this.comeback = false;
		this.loading = true;
		this.isWarning = isWarning;
	}
	isFromUser(comeback = true)
	{
		this.comeback = comeback;
		this.fromUser = true;
		this.loading = false;

		return this;
	}
	isLoaded()
	{
		this.loading = false;

		return this;
	}
	/**
	 * Compute how long bouncing dots are displayed, based on text length
	 */
	calculateTypingTime()
	{
		const charPerSecond = 100;
		let time = Math.round((this.text.length / charPerSecond) * 1000);

		return Math.min(time, 2500);
	}
	resolve(variables)
	{
		super.resolve(variables);
		this.text = Instruction._resolveValue(this.text, variables);
	}
	show()
	{
		if( this.loading )
		{
			return new Promise((resolve) => setTimeout(resolve, this.calculateTypingTime()))
				.then(() => this.isLoaded());
		}
	}
}

export default Message
